import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ObjectManagerComponentBase } from '../../../core/component/object-manager/object-manager.base';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { ColumnDefinitionService } from '../../service/data/column-definition.service';
import { TypeOfKey } from '../../model/type-of-key';
import { KeyTypeService } from '../../service/data/key-type.service';
import { KeyTypeCommandHandlerResolver } from '../../service/command/key-type-command-handler-resolver.service';

@Component({
    selector: 'app-key-type-manager',
    templateUrl: 'key-type-manager.component.html',
    styleUrls: ['key-type-manager.component.scss', './../../../core/component/object-manager/object-manager.template.scss'],
    providers: [KeyTypeCommandHandlerResolver],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class KeyTypeManagerComponent extends ObjectManagerComponentBase<TypeOfKey> {
  constructor(
    columnDefinitionService: ColumnDefinitionService,
    _dataService: KeyTypeService,
    dispatcher: CommandDispatcher,
    handlerResolver: KeyTypeCommandHandlerResolver,
    messageService: MessageService,
    navigationService: NavigationService
  ) {
    super(_dataService, messageService, navigationService, dispatcher, handlerResolver);
    this.columnDefinition = columnDefinitionService.create('KeyType');
    this.title = 'KEYTYPE.LIST_HEADER';
    this.preferencesKey = 'rent.key-type-manager.list';
  }

  ngOnInit() {
    super.ngOnInit();
    this.addEditDeleteCommands();
  }
}
